// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper__chat-box[data-v-6904df80]{position:relative}.margin-custom-0__b[data-v-6904df80]{margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
